/* global Sys:true */
// the above line makes the linter ignore Sys.* errors, Sys DOES exist, it is part of ASP.Net, but logically it does NOT exist 'here'
// requires for external dependencies and other global stuff go here
/* eslint-disable no-unused-vars */
import helper from './util/helper';
import axios from 'axios';
import $ from 'jquery';
import tether from 'tether';
import * as bootstrap from 'bootstrap';
import enquire from 'enquire.js';
import slick from 'slick-carousel';
import jmh from 'jquery-match-height';
import savvior from 'savvior';
import Vue from 'vue';
import Vuex from 'vuex';
import fancybox from '@fancyapps/fancybox';
import AzureSearchBootstrapper from './modules/azureSearch/azureSearch.bootstrapper';
import TakeOverActivityLogger from './modules/TakeOverActivityLogger';
import DownloadActivityLogger from './modules/DownloadActivityLogger';
import FAQActivityLogger from './modules/FAQActivityLogger';
import KeukenDetailActivityLogger from './modules/KeukenDetailActivityLogger';

/* eslint-enable no-unused-vars */

// make sure Promise is present
require('es6-promise/auto');

// make sure that jquery is globally accessible
window.jQuery = window.$ = $;

// use this function to add things that you want to run when the application runs first time (when init is called)
function startup()
{
    $(document).ready(function ()
    {
        var body = document.getElementsByTagName('BODY')[0];
        var actiebanner = document.getElementById('actiebanner');

        const items = document.querySelectorAll('.fly-in');

        window.onscroll = function () {
            // Don't run the rest of the code if every section is already visible
            if (document.querySelectorAll('.fly-in:not(.come-in)').length === 0) return;

            // Run this code for every item in items
            for (const item of items) {
                if (item.getBoundingClientRect().top <= window.innerHeight && item.getBoundingClientRect().top > 0) {
                    item.classList.add('come-in');
                }
            }
        };

        if ($('.block-take-overlay-inner')) {
            TakeOverActivityLogger.init();
        }

        if ($('.download-overview')) {
            DownloadActivityLogger.init();
        }

        if ($('.webpart-faq')) {
            FAQActivityLogger.init();
        }

        if ($('.block-keukenfilters')) {
            KeukenDetailActivityLogger.init();
        }
        // This is needed because the Take-Over is in a Update-Panel
        if (typeof Sys !== 'undefined' && Sys && Sys.Application) {
            Sys.Application.add_load(() => {
                TakeOverActivityLogger.init();
            });
        }
        if (document.documentElement.clientWidth >= 992) {
            $('.submenuitem .dropdown-toggle').removeClass();
        }

        if (actiebanner != null) {
            body.classList.add('actiebanner');
        }
    });
}

// use this function for things you want to happen on (partial-)postback (i.e.: $(document).ready())
function onDocLoad()
{
    $('.dropdown-menu-2 a.dropdown-toggle').on('click', function (e)
    {
        if (!$(this).next().hasClass('show'))
        {
            $(this).parents('.dropdown-menu-2').first().find('.show').removeClass('show');
        }
        var $subMenu = $(this).next('.dropdown-menu-2');
        $subMenu.toggleClass('show');
        $(this).parents('li.nav-item.dropdown.show').on('hidden.bs.dropdown', function (e)
        {
            $('.dropdown-submenu .show').removeClass('show');
        });
        return false;
    });

    $('.slider').slick({
        fade: true,
        autoplay: true,
        autoplaySpeed: 8000,
        speed: 1000,
        arrows: false,
        dots: true,
        appendDots: $('.sliderdots')
    });

    $('.webpart-item-slider .item-slider').slick({
        dots: true,
        arrows: false,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 4000,
        speed: 600,
        slidesToShow: 2,
        slidesToScroll: 2,
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });

    $('.webpart-image-slider .item-slider').slick({
        dots: true,
        arrows: false,
        infinite: false,
        autoplay: true,
        autoplaySpeed: 4000,
        speed: 600,
        slidesToShow: 2,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });

    $('.tiles-slider').slick({
        dots: true,
        arrows: false,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 4000,
        speed: 600,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });

    $(function () {
        $('.tiles-slider .slick-track .slick-slide').matchHeight(
        {
            byRow: true,
            property: 'height',
            target: null,
            remove: false
        });
    });

    $(function () {
        $('.images-technisch-large .slick-track .slick-slide').matchHeight(
        {
            byRow: true,
            property: 'height',
            target: null,
            remove: false
        });
    });

    if ($('.product-image-gallery').length) {
        $('.images-large').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: false,
            arrows: false,
            asNavFor: '.images-small',
            responsive: [
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        arrows: true
                    }
                }
            ]
        });
        $('.images-small').slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            infinite: false,
            asNavFor: '.images-large',
            arrows: true,
            dots: false,
            variableWidth: true,
            focusOnSelect: true
        });
    }

    if ($('.webpart-technischslider').length) {
        $('.images-technisch-large').slick({
            slidesToShow: 2,
            slidesToScroll: 1,
            infinite: false,
            arrows: false,
            asNavFor: '.images-technisch-small',
            responsive: [
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        arrows: true
                    }
                }
            ]
        });
        $('.images-technisch-small').slick({
            slidesToShow: 4,
            centerMode: false,
            slidesToScroll: 1,
            infinite: true,
            asNavFor: '.images-technisch-large',
            arrows: false,
            dots: false,
            variableWidth: true,
            focusOnSelect: true
        });
    }


    if ($('#inspiratietips').length) {
        savvior.init('#inspiratietips', {
            'screen and (max-width: 751px)': { columns: 1 },
            'screen and (min-width: 752px) and (max-width: 1199.98px)': { columns: 2 },
            'screen and (min-width: 1200px)': { columns: 3 }
        });
    }

    $('.popover-tooltip').popover({
        trigger: 'focus hover',
        template: '<div class="popover" role="tooltip"><div class="arrow"></div><h3 class="popover-header"></h3><div class="popover-body"></div></div>'
    });

    var urlString = document.location.toString();
    var urlName = urlString.split('#anchor')[1];
    if (urlString.match('#')) {
        $('#collapse' + urlName).addClass('show');
        $('#card' + urlName).addClass('active');
        $('#card' + urlName + ' a').removeClass('collapsed');
        $('#card' + urlName).addClass('highlighted');
        setTimeout(function () {
            $('#card' + urlName).removeClass('active');
            $('div#card' + urlName).removeClass('highlighted');
        }, 1000);
    }

    if (document.documentElement.clientWidth >= 992) {
        $('.submenuitem .dropdown-toggle').removeClass('dropdown-toggle').addClass('dropdown-notoggle');
    } else {
        $('.submenuitem .dropdown-notoggle').removeClass('dropdown-notoggle').addClass('dropdown-toggle');
    }

    var subItems = document.querySelectorAll('ul.dropdown-menu-2 > li.dropdown-submenu > a.dropdown-toggle');

    if (subItems && subItems.length) {
        for (const subItem of subItems) {
            subItem.onclick = function () {
                this.classList.toggle('opened');
            };
        }
    }

    if ($('.my-profile-toggle .ErrorLabel').length) {
        var items = $('.my-profile-toggle');
        for (let i = 0; i < items.length; i++) {
            items[i].classList.toggle('show');
        }
    }

    setupFilter();

    if ($('#productoverviewreturnlink').length) {
        const referrerURL = new window.URL(document.referrer);
        if (referrerURL.pathname.includes('/keukenonderdelen/')) {
            let hrefAttValue = referrerURL.pathname;

            if (hrefAttValue != null && hrefAttValue !== '') {
                $('#productoverviewreturnlink').attr('href', hrefAttValue + '?action=rfs');
            }
        }
    }

    if ($('.shoppingcart-totals .b-modal').length) {
        $('.shoppingcart-totals .b-modal').on('hidden.bs.modal', function () {
            document.location = window.location;
        });
    }
}

function setupFilter()
{
    let filterInstance = new AzureSearchBootstrapper();
    if (!filterInstance) console.log('no filters');
}

// Init function, can be used for startup stuff
function init()
{
    try
    {
        let done = false;

        startup();
        $(document).ready(() =>
        {
            onDocLoad();
            done = true;

            if (typeof Sys !== 'undefined' && Sys && Sys.Application) {
                Sys.Application.add_load((sender, args) => {
                    if (!done) onDocLoad();
                });
            }
        });
    }
    catch (ex)
    {
    }
}

export default {
    init
};



// WEBPACK FOOTER //
// ./CMS/scripts/global.js